document.addEventListener("DOMContentLoaded", () => {
    const techHeaderCategoryContainer = document.querySelector(".technology-header-section-category-wrapper");
    const techHeaderSubCategoryContainer = document.querySelector(".technology-header-section-sub-category-wrapper");
    const techSidebarFilterContent = document.querySelector(".tech-sidebar-filter-content");


    // Select all sections
    const techCategories = document.querySelectorAll("section.technology-section");
    if (!techCategories.length) return;

    // Create category pills
    techCategories.forEach((section, index) => {
        const categoryPill = document.createElement('div');
        if(index == 0){
            categoryPill.classList.add('technology-header-category-pill', 'scrolled-active');
        }else{
            categoryPill.classList.add('technology-header-category-pill');
        }
        categoryPill.innerHTML = `<a class="text-content" href="#${section.id}">${section.id}</a>
            <button class="tech-filter-close-btn">×</button>
        `;
        techHeaderCategoryContainer.appendChild(categoryPill);
    });

    if(techHeaderSubCategoryContainer){
        const subCategories = techCategories[0].querySelectorAll(".technology-content__container li.tech-sub");
        subCategories.forEach((subCategory, index) => {
            const subCategoryPill = document.createElement('div');
            if(index == 0){
                subCategoryPill.classList.add("technology-header-sub-category-pill", "active")
            }else{
                subCategoryPill.classList.add("technology-header-sub-category-pill");
            }

            subCategoryPill.innerHTML = `<a class="sub-category-text-content" href="#${subCategory.id}">${subCategory.id}</a>`;
            techHeaderSubCategoryContainer.appendChild(subCategoryPill);
        })
    }

    // Handling Sorting and Filtering through clicks on category pills...
    const categoryPills = document.querySelectorAll(".technology-header-category-pill");
    if(categoryPills){
        categoryPills.forEach(categoryPill => {
            categoryPill.addEventListener("click", (e) => {
                if(e.target.matches('a.text-content')){
                    const categoriesMainContainer = categoryPill.closest(".technology-header-section-container");
                    const subCategoryWrapper = categoriesMainContainer.querySelector(".technology-header-section-sub-category-wrapper");
                    categoriesMainContainer.style.paddingBottom = "0px"
                    subCategoryWrapper.style.display = "flex";
    
                    categoryPills.forEach(cp => {
                        cp.classList.remove("clicked-active");
                    });
    
                    categoryPill.classList.add("clicked-active");
    
                    techCategories.forEach(techCategory => {
                        if(techCategory.id == categoryPill.querySelector(".text-content").textContent){
                            techCategory.style.display = "flex";
                        }else{
                            techCategory.style.display = "none";
                        }
                    })
                }else if(e.target.matches('button.tech-filter-close-btn')){
                    const categoriesMainContainer = categoryPill.closest(".technology-header-section-container");
                    const subCategoryWrapper = categoriesMainContainer.querySelector(".technology-header-section-sub-category-wrapper");
                    categoriesMainContainer.style.paddingBottom = "24px"
                    subCategoryWrapper.style.display = "none";

                    categoryPill.classList.remove("clicked-active");
                    techCategories.forEach(tc => {
                        tc.style.display = "flex";
                    })
                }
            })
        })
    }


    if (techSidebarFilterContent && techCategories) {
        const subCategoriesfilter = document.querySelectorAll("li[data-source]");

        const allFilter = document.createElement("details");
        allFilter.classList.add("link-dropdown-container");

        const summary = document.createElement("summary");
        summary.classList.add("parent-dropdown-link");
        summary.innerHTML = `
            <span class="tech-filter-summary-title">All Tech</span>
            <span class="dropdown-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                    <path d="M11.2946 0.294705C10.9053 -0.0945674 10.2743 -0.0949114 9.88462 0.293936L6.07063 4.09961C6.0316 4.13856 5.9684 4.13856 5.92937 4.09961L2.11538 0.293935C1.72569 -0.0949132 1.09466 -0.094569 0.705384 0.294704C0.315811 0.684277 0.315811 1.3159 0.705384 1.70547L5.29289 6.29298C5.68342 6.68351 6.31658 6.68351 6.70711 6.29298L11.2946 1.70547C11.6842 1.3159 11.6842 0.684279 11.2946 0.294705Z" fill="#010607"/>
                </svg>
            </span>
        `;

        const list = document.createElement("ul");
        list.classList.add("dropdown-menus");
        list.setAttribute("tabindex", "-1");

        subCategoriesfilter.forEach(subCategory => {
            const li = document.createElement("li");
            li.innerHTML = `<a href="#${subCategory.id}">${subCategory.id}</a>`;
            list.appendChild(li);
        });

        allFilter.appendChild(summary);
        allFilter.appendChild(list);
        techSidebarFilterContent.appendChild(allFilter);


        techCategories.forEach(techCategory => {
            const techSubCategories = techCategory.querySelectorAll(".technology-content__container .tech-sub");
            const allFilter = document.createElement("details");
            allFilter.classList.add("link-dropdown-container");

            const summary = document.createElement("summary");
            summary.classList.add("parent-dropdown-link");
            summary.innerHTML = `
                <span class="tech-filter-summary-title">${techCategory.id}</span>
                <span class="dropdown-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                        <path d="M11.2946 0.294705C10.9053 -0.0945674 10.2743 -0.0949114 9.88462 0.293936L6.07063 4.09961C6.0316 4.13856 5.9684 4.13856 5.92937 4.09961L2.11538 0.293935C1.72569 -0.0949132 1.09466 -0.094569 0.705384 0.294704C0.315811 0.684277 0.315811 1.3159 0.705384 1.70547L5.29289 6.29298C5.68342 6.68351 6.31658 6.68351 6.70711 6.29298L11.2946 1.70547C11.6842 1.3159 11.6842 0.684279 11.2946 0.294705Z" fill="#010607"/>
                    </svg>
                </span>
            `;

            const list = document.createElement("ul");
            list.classList.add("dropdown-menus");
            list.setAttribute("tabindex", "-1");

            techSubCategories.forEach(subCategory => {
                const li = document.createElement("li");
                li.innerHTML = `<a href="#${subCategory.id}">${subCategory.id}</a>`;
                list.appendChild(li);
            });

            allFilter.appendChild(summary);
            allFilter.appendChild(list);
            techSidebarFilterContent.appendChild(allFilter);
        })


        const dropdowns = Array.from(document.querySelectorAll('.tech-sidebar-filter-content .link-dropdown-container'));
        // Configuration
		const TRANSITION_DURATION = 320; // ms
		const EASE = 'cubic-bezier(.2,.9,.2,1)'; // nicer easing
		const ACCORDION = true; // true = opening one closes the others

        // Helpers
		const pixel = (n) => `${n}px`;
		const getCurrentMaxHeight = (el) => {
			const computed = window.getComputedStyle(el).getPropertyValue('max-height');
			if (computed === 'none') return el.scrollHeight;
			return parseFloat(computed) || el.scrollHeight;
		};

        if(dropdowns.length >= 1){
            dropdowns.forEach((dropdown, idx) => {
                const content = dropdown.querySelector('.dropdown-menus');
                const summary = dropdown.querySelector('summary');

                if (!content || !summary) return;

                if (!content.id) content.id = `menu-dropdown-${idx}`;
                summary.setAttribute('aria-controls', content.id);
                summary.setAttribute('role', 'button');

                // Init styles
                content.style.overflow = 'hidden';
                content.style.transition = `max-height ${TRANSITION_DURATION}ms ${EASE}, opacity ${TRANSITION_DURATION}ms ${EASE}`;
                content.style.maxHeight = '0px';
                content.style.opacity = '0';
                content.style.display = 'none';
                content.style.willChange = 'max-height, opacity';
                dropdown.dataset.animating = 'false';
                summary.setAttribute('aria-expanded', 'false');

                // ✅ Stop summary from auto-scrolling into view
                summary.addEventListener('mousedown', (e) => e.preventDefault());

                // Keyboard UX - Space & Enter
                summary.addEventListener('keydown', (ev) => {
                    if (ev.key === ' ' || ev.key === 'Spacebar' || ev.key === 'Enter') {
                        ev.preventDefault();
                        ev.stopPropagation();

                        // Instead of summary.click(), call toggle logic directly
                        const icon = dropdown.querySelector('.dropdown-icon');
                        if (dropdown.hasAttribute('open')) {
                            animateClose(dropdown, content, icon);
                        } else {
                            animateOpen(dropdown, content, icon, summary);
                        }
                    }
                });

                // Click handler
                summary.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    ev.stopPropagation();

                    if (dropdown.dataset.animating === 'true') return;

                    // Accordion behavior
                    if (ACCORDION) {
                    dropdowns.forEach((other) => {
                        if (other === dropdown) return;
                        if (other.hasAttribute('open')) {
                        const otherContent = other.querySelector('.dropdown-menus');
                        const otherIcon = other.querySelector('.dropdown-icon');
                        if (other.dataset.animating !== 'true') animateClose(other, otherContent, otherIcon);
                        }
                    });
                    }

                    const icon = dropdown.querySelector('.dropdown-icon');
                    if (dropdown.hasAttribute('open')) {
                    animateClose(dropdown, content, icon);
                    } else {
                    animateOpen(dropdown, content, icon, summary);
                    }
                });
            });

			// Open animation
			function animateOpen(dropdown, content, icon, summary) {
				dropdown.dataset.animating = 'true';
				dropdown.setAttribute('open', '');
				summary && summary.setAttribute('aria-expanded', 'true');

				content.style.display = 'block';
				if (getComputedStyle(content).getPropertyValue('max-height') === 'none') {
					content.style.maxHeight = pixel(content.scrollHeight);
				} else {
					content.style.maxHeight = '0px';
					content.style.opacity = '0';
				}

				content.getBoundingClientRect(); // reflow

				const full = content.scrollHeight;
				requestAnimationFrame(() => {
					content.style.transition = `max-height ${TRANSITION_DURATION}ms ${EASE}, opacity ${TRANSITION_DURATION}ms ${EASE}`;
					content.style.maxHeight = pixel(full);
					content.style.opacity = '1';
					if (icon) icon.style.transform = 'rotate(180deg)';
					try { summary && summary.focus({ preventScroll: true }); } catch (e) {}
				});

				const onEnd = (e) => {
					if (e.propertyName && e.propertyName !== 'max-height') return;
					content.style.maxHeight = 'none';
					dropdown.dataset.animating = 'false';
					content.removeEventListener('transitionend', onEnd);
				};
				content.addEventListener('transitionend', onEnd);
			}

			// Close animation
			function animateClose(dropdown, content, icon) {
				dropdown.dataset.animating = 'true';
				const startH = getCurrentMaxHeight(content) || content.scrollHeight;
				content.style.maxHeight = pixel(startH);
				content.style.opacity = '1';

				content.getBoundingClientRect(); // reflow

				requestAnimationFrame(() => {
					content.style.transition = `max-height ${TRANSITION_DURATION}ms ${EASE}, opacity ${TRANSITION_DURATION}ms ${EASE}`;
					content.style.maxHeight = '0px';
					content.style.opacity = '0';
					if (icon) icon.style.transform = 'rotate(0deg)';
					const summary = dropdown.querySelector('summary');
					summary && summary.setAttribute('aria-expanded', 'false');
				});

				const onEnd = (e) => {
					if (e.propertyName && e.propertyName !== 'max-height') return;
					content.style.display = 'none';
					dropdown.removeAttribute('open');
					dropdown.dataset.animating = 'false';
					content.removeEventListener('transitionend', onEnd);
				};
				content.addEventListener('transitionend', onEnd);
			}
        }






        // === Handle clicks on sidebar links ===
        techSidebarFilterContent.addEventListener("click", (e) => {
            const link = e.target.closest("a[href^='#']");
            if (!link) return; // not a link

            e.preventDefault();

            // 1️⃣ Close all accordions
            const allDropdowns = document.querySelectorAll(".tech-sidebar-filter-content details[open]");
            allDropdowns.forEach(drop => {
                const content = drop.querySelector(".dropdown-menus");
                const icon = drop.querySelector(".dropdown-icon");
                if (drop.dataset.animating !== 'true') {
                    animateClose(drop, content, icon);
                }
            });

            // 2️⃣ Close sidebar and overlay
            const sidebar = document.querySelector(".tech-sidebar-filter");
            const sectionContainer = sidebar.closest(".technology-header-section");
            const overlay = document.querySelector(".tech-overlay");
            const body = document.body;
            sidebar.classList.remove("open"); 
            sectionContainer.style.zIndex = '9';
            overlay.classList.remove("show");
            body.style.overflow = "auto";

            // 3️⃣ Smooth scroll to the section
            const targetId = link.getAttribute("href").substring(1);
            const target = document.getElementById(targetId);
            if (target) {
                const parentTechSection = target.closest("section.technology-section");
                techCategories.forEach(tc => {
                    if(tc.id == parentTechSection.id){
                        tc.style.display = "flex";
                        const categoryPills = document.querySelectorAll(".technology-header-category-pill");
                        categoryPills.forEach(cp => cp.classList.remove("clicked-active"));
                        categoryPills.forEach(cp => {
                            if(cp.querySelector(".text-content").textContent == parentTechSection.id){
                                cp.classList.add("clicked-active");
                                const categoriesMainContainer = cp.closest(".technology-header-section-container");
                                const subCategoryWrapper = categoriesMainContainer.querySelector(".technology-header-section-sub-category-wrapper");
                                categoriesMainContainer.style.paddingBottom = "0px"
                                subCategoryWrapper.style.display = "flex";
                            }
                        })
                    }else{
                        tc.style.display = "none";
                    }
                })
                // small delay ensures transitions finish before scroll
                setTimeout(() => {
                    target.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                }, 300);
            }
        });

    }




    // IntersectionObserver to log section ID when it enters viewport
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const techHeaderCategoryPills = document.querySelectorAll(".technology-header-category-pill")
                    techHeaderCategoryPills.forEach(categoryPill => {
                        categoryPill.classList.remove("scrolled-active")
                    })

                    techHeaderCategoryPills.forEach(categoryPill => {
                        if(categoryPill.querySelector(".text-content").textContent == entry.target.id){
                            categoryPill.classList.add("scrolled-active");
                        }
                    });

                    if(techHeaderSubCategoryContainer){
                        techHeaderSubCategoryContainer.innerHTML = '';
                        const subCategories = entry.target.querySelectorAll(".technology-content__container li.tech-sub");
                        subCategories.forEach((subCategory, index) => {
                            const subCategoryPill = document.createElement('div');
                            if(index == 0){
                                subCategoryPill.classList.add("technology-header-sub-category-pill", "active")
                            }else{
                                subCategoryPill.classList.add("technology-header-sub-category-pill");
                            }

                            subCategoryPill.innerHTML = `<a class="sub-category-text-content" href="#${subCategory.id}">${subCategory.id}</a>`;
                            techHeaderSubCategoryContainer.appendChild(subCategoryPill);
                        });
                        observeSubSections(entry.target);
                    }
                }
            });
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 0.1 
        }
    );

    let subObserver;
    function observeSubSections(activeSection) {
        // Disconnect old observer to avoid overlap
        if (subObserver) subObserver.disconnect();

        const subSections = activeSection.querySelectorAll(".tech-sub");
        const subPills = document.querySelectorAll(".technology-header-sub-category-pill");

        subObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const techHeaderSubCategoryPills = document.querySelectorAll(".technology-header-sub-category-pill")
                        techHeaderSubCategoryPills.forEach(subCategoryPill => {
                            subCategoryPill.classList.remove("active")
                        })

                        techHeaderSubCategoryPills.forEach(subCategoryPill => {
                            if(subCategoryPill.textContent == entry.target.id){
                                subCategoryPill.classList.add("active");
                            }
                        });
                    }
                });
            },
            {
                root: null,
                threshold: 0.3
            }
        );

        // Observe all sub-sections
        subSections.forEach(subSection => subObserver.observe(subSection));
    }


    // Observe all sections
    techCategories.forEach(section => observer.observe(section));
});



function toggleSidebar() {
    const sidebar = document.querySelector('.tech-sidebar-filter');
    const overlay = document.querySelector('.tech-overlay');
    const body = document.body;
    const sectionContainer = sidebar.closest(".technology-header-section");

    sidebar.classList.toggle('open');
    overlay.classList.toggle('show');

    // toggle body scroll
    if (sidebar.classList.contains('open')) {
        body.style.overflow = 'hidden'; // prevent scrolling
        sectionContainer.style.zIndex = '99';
    } else {
        body.style.overflow = 'auto'; // restore scrolling
        sectionContainer.style.zIndex = '9';
    }
}
